import { render, staticRenderFns } from "./CalculatePartner.vue?vue&type=template&id=10f8fb1c"
import script from "./CalculatePartner.vue?vue&type=script&lang=js"
export * from "./CalculatePartner.vue?vue&type=script&lang=js"
import style0 from "./CalculatePartner.vue?vue&type=style&index=0&id=10f8fb1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports